import React from 'react';

const ErrorMessage = ({ message, show, className = '', color = 'is-danger'}) => !show ? null : (
  <p className={`help ${color} ${className}`}>{message}</p>
);

export default ErrorMessage;
